<div class="input-component"
     [formGroup]="formGroup"
     *ngIf="controlStatus | async as status"
     [class.pristine]="!status.dirty"
     [class.valid]="!status.invalid"
     [class.invalid]="status.invalid"
     [class.required]="required">
    <div class="input-wrapper">
        <input type="text"
               class="input-field"
               [attr.required]="required"
               [attr.value]="control.value"
               [id]="fieldId"
               [formControlName]="ctrlName" />
        <label [attr.for]="fieldId">{{label | translate}}</label>
        <aa-check-mark9 [status]="status">
        </aa-check-mark9>
    </div>
    <aa-field-msg-error [status]="status">
    </aa-field-msg-error>
</div>
